/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AmoxcalliReassignGroupDto } from '../../models/amoxcalli-reassign-group-dto';

export interface ApiTeacherInstitutionsInstitutionIdUserIdGroupPatch$Params {
  institutionId: string;
  userId: string;
      body?: AmoxcalliReassignGroupDto
}

export function apiTeacherInstitutionsInstitutionIdUserIdGroupPatch(http: HttpClient, rootUrl: string, params: ApiTeacherInstitutionsInstitutionIdUserIdGroupPatch$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, apiTeacherInstitutionsInstitutionIdUserIdGroupPatch.PATH, 'patch');
  if (params) {
    rb.path('institutionId', params.institutionId, {});
    rb.path('userId', params.userId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

apiTeacherInstitutionsInstitutionIdUserIdGroupPatch.PATH = '/api/teacher-institutions/{institutionId}/{userId}/group';
